module.exports = __webpack_public_path__ + "media/application/images/svgs/icon-check-c1e7372f493706f7391b7bd254e9bcc0.svg";